var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Comment_1;
import { ShapeSet } from 'lincd/collections/ShapeSet';
import { objectProperty } from 'lincd/shapes/SHACL';
import { schema } from '../ontologies/schema.js';
import { linkedShape } from '../package.js';
import { Thing } from './Thing.js';
let Comment = Comment_1 = class Comment extends Thing {
    get parentItem() {
        return this.getOneAs(schema.parentItem, Comment_1, true);
    }
    set parentItem(val) {
        this.overwrite(schema.parentItem, val ? val.node : null);
    }
    get childItem() {
        return this.getOneAs(schema.childItem, Comment_1, true);
    }
    set childItem(val) {
        this.overwrite(schema.childItem, val ? val.node : null);
    }
    get childItems() {
        //note that `true` makes sure that the items can turn into other shapes that extend Comment
        return Comment_1.getSetOf(this.getAllInverse(schema.parentItem), true);
    }
};
Comment.targetClass = schema.Comment;
__decorate([
    objectProperty({
        path: schema.parentItem,
        shape: Comment,
        maxCount: 1,
    }),
    __metadata("design:type", Comment),
    __metadata("design:paramtypes", [Comment])
], Comment.prototype, "parentItem", null);
__decorate([
    objectProperty({
        path: schema.childItem,
        shape: Comment,
        maxCount: 1,
    }),
    __metadata("design:type", Comment),
    __metadata("design:paramtypes", [Comment])
], Comment.prototype, "childItem", null);
__decorate([
    objectProperty({
        path: schema.childItem,
        shape: Comment,
    }),
    __metadata("design:type", ShapeSet),
    __metadata("design:paramtypes", [])
], Comment.prototype, "childItems", null);
Comment = Comment_1 = __decorate([
    linkedShape({
        description: 'A comment on an item. Represents user feedback with parent-child relationships and threaded discussions. (feedback, remark, note)',
    })
], Comment);
export { Comment };
//# sourceMappingURL=Comment.js.map